module.exports = __webpack_public_path__ + "static/img/zngc_banner@2x.07eb3dff.png";